<template>
    <span>
        <label v-bind:for="label" class="mr-10" v-for="option in options">
            <input type="radio" :name="name" :id="option.label" class="shadow-sm" :value="option.value"
                   @input="$emit('input', $event.target.value)" ref="input">
            {{ option.label }}
        </label>
    </span>
</template>

<script>
export default {
    props: ['options', 'label', 'name'],
    methods: {
        focus() {
            this.$refs.input.focus()
        }
    }
}
</script>

